module.exports = __webpack_public_path__ + "img/FNAC.95ce1c87b9b0031117c9bc5874155cf3.jpg";